import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Image, Icon, Header, Label, Sidebar, Button, Table, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import { formatPrice } from '../../../helpers/format';
import { fetchLoyaltyProgramMembers, removeMemberFromLoyaltyProgram, setEditedEntity, confirmDelete } from '../../../actions';
import { getLPMembers } from '../../../selectors';
import MemberEditor from './MemberEditor';

class Members extends Component {

    constructor(props) {
        super(props);

        this.handleMemberRemoval = this.handleMemberRemoval.bind(this);
        this.renderCreationButton = this.renderCreationButton.bind(this);
    }

    componentWillMount() {
        const { loyaltyProgram, fetchLoyaltyProgramMembers } = this.props;
        if (loyaltyProgram && loyaltyProgram.membersIds) {
            const lpMembers = loyaltyProgram.name === 'Paidit' ? null : loyaltyProgram.membersIds;
            fetchLoyaltyProgramMembers(loyaltyProgram.id, lpMembers);
        }
    }

    handleMemberRemoval(member) {
        const { confirmDelete, removeMemberFromLoyaltyProgram, loyaltyProgram } = this.props;
        confirmDelete(member.name, () => removeMemberFromLoyaltyProgram(loyaltyProgram.id, member.id));
    }

    renderCreationButton() {
        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                primary
                onClick={() => setEditedEntity('member')}
                floated='right'
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { history, loyaltyProgram, members, onEdit, setEditedEntity } = this.props;

        if (!loyaltyProgram) return null;

        const columns = [{
            id: 'index',
            Header: '#',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            Cell: row => ++row.index
        }, {
            id: 'member-name',
            Header: i18next.t('name'),
            accessor: member => member.unregistered ? i18next.t('unregisted') : member.name,
            filterable: true
        }, {
            Header: i18next.t('phone'),
            accessor: 'phone',
            filterable: true
        }, {
            Header: i18next.t('email'),
            accessor: 'email',
            filterable: true
        }, {
            id: 'createdAt',
            Header: i18next.t('createDate'),
            accessor: 'createdAt',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date()
        }, {
            Header: i18next.t('birthdate'),
            accessor: 'birthdate',
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            maxWidth: 120,
            sortable: false,
            filterable: false,
            Cell: row => {
                const member = row.original;
                return (
                    <div>
                        {
                            loyaltyProgram.name === "Paidit" ?
                            <Button
                                circular
                                size='tiny'
                                icon='find'
                                primary
                                onClick={() => history.push(`/loyaltyProgram/${loyaltyProgram.id}/members/${member.id}`)}
                            />
                            :
                            <Button circular size='tiny' icon='trash' negative onClick={() => this.handleMemberRemoval(member)} />
                        }
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('loyaltyProgram.members')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <MemberEditor loyaltyProgramId={loyaltyProgram.id} />
                </SideEditor>
                <DataGrid
                    data={members}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        if (typeof rowInfo !== "undefined" && rowInfo.original && rowInfo.original.unregistered) {
                            return { className: 'pi-data-grid-row-negative' };
                        }
                        return {};
                    }}
                    paginated
                    extraActions={this.renderCreationButton()}
                   
                />
            </div>
        );
    }
}

Members.propTypes = {
    history: PropTypes.object,
    fetchLoyaltyProgramMembers: PropTypes.func,
    removeMemberFromLoyaltyProgram: PropTypes.func,
    loyaltyProgram: PropTypes.object,
    members: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    confirmDelete: PropTypes.func,
    
};

function mapStateToProps(state) {
    const members = getLPMembers(state);
    const onEdit = state.editor.type === 'member';

    return { members, onEdit };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramMembers,
    removeMemberFromLoyaltyProgram,
    setEditedEntity,
    confirmDelete,
})(Members);
